import { Typography } from "@cpj-ai/panel-npm-package";
import { Button, Chip, Divider, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from "@heroui/react";
import { UserSuggestionType } from "..";
import { NameCell } from "./NameCell";

interface SuggestionDetailsModalProps {
  isOpen: boolean;
  onClose: () => void;
  suggestion: UserSuggestionType | null;
}

export const SuggestionDetailsModal: React.FC<SuggestionDetailsModalProps> = ({ isOpen, onClose, suggestion }) => {
  if (!suggestion) return null;

  const jobSeeker = suggestion.user;

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="2xl">
      <ModalContent>
        <ModalHeader className="flex flex-col gap-1">
          <div className="flex items-center gap-2">
            <Typography className="text-lg font-bold">Candidate Match Details</Typography>
            <Chip color="primary" variant="flat" className="ml-2">
              {suggestion.matchScore || 0}% Match
            </Chip>
          </div>
        </ModalHeader>
        <ModalBody>
          <div className="grid grid-cols-1 gap-4">
            <div className="flex items-center gap-4">
              <NameCell jobSeeker={jobSeeker} />
            </div>

            <Divider />

            <div>
              <Typography className="text-md font-semibold mb-2">Match Explanation</Typography>
              <Typography className="text-sm">{suggestion.matchExplanation || "No explanation available."}</Typography>
            </div>

            <div className="grid grid-cols-3 gap-4">
              <div>
                <Typography className="text-sm font-semibold">Skill Match</Typography>
                <Typography className="text-lg font-bold">{suggestion.skillMatch || 0}%</Typography>
              </div>
              <div>
                <Typography className="text-sm font-semibold">Experience Match</Typography>
                <Typography className="text-lg font-bold">{suggestion.experienceMatch || 0}%</Typography>
              </div>
              <div>
                <Typography className="text-sm font-semibold">Seniority Match</Typography>
                <Typography className="text-lg font-bold">{suggestion.seniorityMatch || 0}%</Typography>
              </div>
            </div>

            <div>
              <Typography className="text-md font-semibold mb-2">Recommendation Level</Typography>
              <Typography className="text-lg font-bold">
                {suggestion.recommendation ? `${suggestion.recommendation}/5` : "No recommendation"}
              </Typography>
            </div>

            <div>
              <Typography className="text-md font-semibold mb-2">Confidence Level</Typography>
              <Typography className="text-lg font-bold">
                {suggestion.confidenceLevel ? `${suggestion.confidenceLevel}/5` : "No confidence level"}
              </Typography>
            </div>

            {suggestion.strengths && suggestion.strengths.length > 0 && (
              <div>
                <Typography className="text-md font-semibold mb-2">Strengths</Typography>
                <ul className="list-disc pl-5">
                  {suggestion.strengths.map((strength, index) => (
                    <li key={index} className="text-sm">
                      {strength}
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {suggestion.considerations && suggestion.considerations.length > 0 && (
              <div>
                <Typography className="text-md font-semibold mb-2">Considerations</Typography>
                <ul className="list-disc pl-5">
                  {suggestion.considerations.map((consideration, index) => (
                    <li key={index} className="text-sm">
                      {consideration}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" variant="light" onPress={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
